import React from 'react';

import {Link} from 'react-router';

import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {DateText, FixableHeader, FixableTable} from './utils';

import type {
  BasicFolderSerializedType,
  BasicTeamSerializedType,
  ContentType,
  ReportResultSerializedType,
} from 'sweet-types';

interface Props {
  result: ReportResultSerializedType<{
    content_type: ContentType & ('procedure' | 'policy' | 'proceduregroup');
    tags: string;
    last_review_at: string;
    next_review_at: string;
    approved_at: string;
    edited_at: string;
    hashid: string;
    html_url: string;
    name: string;
    url: string;
    teams: Array<BasicTeamSerializedType>;
    folders: Array<BasicFolderSerializedType>;
  }>;
}

export function RenderListDocuments({result}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Tags')}</FixableHeader>
          <FixableHeader>{gt('Teams')}</FixableHeader>
          <FixableHeader>{gt('Folders')}</FixableHeader>
          <FixableHeader>{gt('Document type')}</FixableHeader>
          <FixableHeader>{gt('Last Review Date')}</FixableHeader>
          <FixableHeader>{gt('Next Review Date')}</FixableHeader>
          <FixableHeader>{gt('Last Approved Date')}</FixableHeader>
          <FixableHeader>{gt('Last Edited Date')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <Link className="font-weight-bold" to={r.html_url}>
                {r['name']}
              </Link>
            </td>
            <td>{r['tags']}</td>
            <td>
              <ul className="mb-0 pl-4">
                {r.teams.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.folders.map((f) => (
                  <li key={f.html_url}>
                    <Link to={f.html_url}>{f.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td>{printContentType(r['content_type'])}</td>
            <td>
              <DateText>{r['last_review_at']}</DateText>
            </td>
            <td>
              <DateText>{r['next_review_at']}</DateText>
            </td>
            <td>
              <DateText>{r['approved_at']}</DateText>
            </td>
            <td>
              <DateText>{r['edited_at']}</DateText>
            </td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
